import React from 'react'

import GenericFormDialog from './GenericFormDialog'
import { AppContext } from '../contexts/AppProvider'
import { sendEmail } from '../api/email_api'
import { EmailType, NewUnitRequestEmailPayload } from '../types/apiTypes'
import { upperFirst } from '../utils/miscUtils'

interface NewUnitRequestDialogProps {
  open: boolean
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
}

const NewUnitRequestDialog: React.FC<NewUnitRequestDialogProps> = ({ open, setOpen }) => {
  const { appState } = React.useContext(AppContext)
  const { currentMeasure } = appState

  const fields = [
    { id: 'senderEmail', label: 'Your email', type: 'email' },
    {
      id: 'measure',
      label: 'Measure',
      initialValue: upperFirst(currentMeasure.displayName),
      type: 'text',
      disabled: true
    },
    { id: 'unit', label: 'Requested unit', type: 'text', required: true },
    { id: 'message', label: 'Additional message', type: 'text', multiline: true, rows: 4 }
  ]

  const preparePayload = (state: Record<string, string>): NewUnitRequestEmailPayload => ({
    email_request: {
      email_type: EmailType.NewUnitRequest,
      measure: state.measure,
      unit: state.unit,
      ...(state.senderEmail && { sender_email: state.senderEmail }),
      ...(state.message && { message: state.message })
    }
  })

  const isSubmissionInvalid = (state: Record<string, string>): boolean => {
    return !state.unit
  }

  return (
    <GenericFormDialog
      open={open}
      setOpen={setOpen}
      title="Request Missing Unit"
      fields={fields}
      apiFunction={sendEmail}
      preparePayload={preparePayload}
      successMessage="New unit request sent successfully! Thank you for getting in touch."
      isSubmissionInvalid={isSubmissionInvalid}
    />
  )
}

export default NewUnitRequestDialog
